var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5,9.2 L8,9.2 L8,19 L5,19 L5,9.2 Z M10.6,5 L13.4,5 L13.4,19 L10.6,19 L10.6,5 L10.6,5 Z M16.2,13 L19,13 L19,19 L16.2,19 L16.2,13 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.dc23722422b8c610f95d0a6a72cbe3e0.svg";
export { ForwardRef as ReactComponent };